import ShippersMain from "../modules/shippersModule/views/Main";
import ShippersDashboard from "../modules/shippersModule/views/Dashboard";
import ShippersNewApplication from "../modules/shippersModule/views/NewShippingRequest";
import SavedApplications from "../modules/shippersModule/views/SavedApplications";
import ApplicationStatusHistory from "../modules/shippersModule/views/ApplicationStatusHistory";
import ApprovedApplications from "../modules/shippersModule/views/ApprovedApplications";
import ShippingApplicationDetails from "../modules/shippersModule/views/ShippingApplicationDetails";
import ImdgGuide from "../modules/shippersModule/views/ImdgGuide";
import ProfileSetting from "../modules/shippersModule/views/ProfileSetting";
import ApproveCertificate from "../modules/commonModule/components/viewShippingRequestDetails/ApproveCertificate";

export default [
  {
    path: "/shipper",
    name: "shipper-main-view",
    component: ShippersMain,
    children: [
      {
        path: "dashboard",
        component: ShippersDashboard,
        name: "shippers-dashboard",
        meta: { requiresAuth: true }
      },
      {
        path: "apply",
        component: ShippersNewApplication,
        name: "shippers-new-application",
        meta: { requiresAuth: true }
      },
      {
        path: "application-status",
        component: ApplicationStatusHistory,
        name: "shippers-application-status",
        meta: { requiresAuth: true }
      },
      {
        path: "saved-applications",
        component: SavedApplications,
        name: "saved-applications",
        meta: { requiresAuth: true }
      },
      {
        path: "approved-applications",
        component: ApprovedApplications,
        name: "shippers-approved-applications",
        meta: { requiresAuth: true }
      },
      {
        path: "/shipper/shipping-application-details/:id",
        name: "shipping-application-details",
        component: ShippingApplicationDetails,
        props: true,
        meta: { requiresAuth: true }
      },

      {
        path: "/shipper/imdg-guide",
        name: "imdg-guide",
        component: ImdgGuide,
        meta: { requiresAuth: true }
      },

      {
        path: "/shipper/profile-settings",
        name: "profile-settings",
        component: ProfileSetting,
        meta: { requiresAuth: true }
      }
    ]
  }
];
